import React from "react"
import { makeStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';

import Helmet from "react-helmet"

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  mapForcast: {
    textAlign: `center`,
    paddingBottom: theme.spacing(2),
  },
  link: {
    fontSize: `1.2rem`
  },
  column: {
    padding: theme.spacing(1),
  }
}));

export const ContentOther = () => {
  const classes = useStyles();
  const url1 = "https://www.data.jma.go.jp/gmd/kaiyou/data/db/kaikyo/daily/sst_HQ.html#main";
  const url2 = "https://www.data.jma.go.jp/gmd/kaiyou/data/db/kaikyo/daily/current_HQ.html";
  const url3 = "https://www.jma.go.jp/bosai/map.html#4/34.5/137/&elem=typhoon_all&typhoon=all&contents=typhoon";

  return (
    <React.Fragment>
      <Helmet>
        { /*https://qiita.com/tommarute/items/8eb51ab2ff4256dd2034
        <script type="module" src="https://unpkg.com/x-frame-bypass"></script>*/}
      </Helmet>
      <div id="map" className={classes.mapForcast}>
        <Grid container direction="column" alignItems="center" justify="center">
          <Grid item xs={12} md={12} className={classes.column}>
            <div>
              { /*<iframe title="temperature" width="100%" height="800" scrolling="no" is="x-frame-bypass" frameBorder="0"　src={url} />*/}
              <a rel="noreferrer" className={classes.link} href={url1} target="_blank">気象庁 | 海面水温に関する診断表、データ 日別海面水温 (jma.go.jp)へ</a>
            </div>
          </Grid>
          <Grid item xs={12} md={12} className={classes.column}>
            <div>
              { /*<iframe title="temperature" width="100%" height="800" scrolling="no" is="x-frame-bypass" frameBorder="0"　src={url} />*/}
              <a rel="noreferrer" className={classes.link} href={url2} target="_blank">気象庁 | 海流に関する診断表、データ 日別海流 (jma.go.jp)へ</a>
            </div>
          </Grid>
          <Grid item xs={12} md={12} className={classes.column}>
            <div>
              { /*<iframe title="temperature" width="100%" height="800" scrolling="no" is="x-frame-bypass" frameBorder="0"　src={url} />*/}
              <a rel="noreferrer" className={classes.link} href={url3} target="_blank">気象庁 | 台風進路図、総合地図ページ (jma.go.jp)へ</a>
            </div>
          </Grid>
        </Grid>
      </div>
    </React.Fragment>
  );
};

export default ContentOther;